import React, { createContext, useContext, useState, useRef, useCallback, useEffect } from "react";
import axiosInstance from "../Config/axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const BrokerContext = createContext();
export const useBroker = () => useContext(BrokerContext);

export const BrokerProvider = ({ children }) => {
 
  const navigate = useNavigate();

const acknowledgeBroker = async (token) => {
  try {
    const response = await axiosInstance.get(
      `/customer/confirm-mou-by-broker/${token}`
    );

    return response.data; // ✅ return success

  } catch (err) {
    throw err; // ✅ throw to UI
  }
};


  return (
    <BrokerContext.Provider value={{ acknowledgeBroker }}>
      
      {children}
    </BrokerContext.Provider>
  );
};
